'use client';
import { useEffect, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import FretboardComponent from '../components/fretboard/FretboardComponent';
import { toast } from 'sonner';

function HomeContent() {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams.get('login') === 'success') {
      toast.success('You have successfully logged in!');
    }
  }, [searchParams]);

  return (
    <div className="space-y-8">
      <FretboardComponent />
      {/* {session && !error && (
        <>
          {isLoading ? (
            <div className="p-4 text-center">Loading practice logs...</div>
          ) : (
            <DailyPracticeLogDisplay logs={logs || []} onDelete={handleDeleteLog} />
          )}
        </>
      )} */}
    </div>
  );
}

export default function HomePage() {
  return (
    <Suspense fallback={<div className="p-4">Loading...</div>}>
      <HomeContent />
    </Suspense>
  );
}
